import keyBy from 'lodash/keyBy'
import { replaceCollections, deleteEntities, replaceEntities } from '@fakundo/redux-entities'
import { LIVE_CHATS } from 'constants/entityNames'

export const fetchLiveChats = cancelToken => (
  (dispatch, getState, api) => api({
    apiPath: 'chat/list',
    cancelToken
  })
)

export const refetchLiveChats = cancelToken => (
  async (dispatch) => {
    const data = await dispatch(fetchLiveChats(cancelToken))
    dispatch(replaceCollections({ [LIVE_CHATS]: { ...keyBy(data, 'uuid') } }))
  }
)

export const getLiveChatToken = (chatUuid, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'get',
    apiPath: `/chat/token/${chatUuid}`,
    cancelToken
  })
)

export const bulkDeleteLiveChats = (liveChatUuids, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'delete',
      apiPath: 'chat/batch',
      data: { chatList: liveChatUuids },
      cancelToken
    })
    dispatch(deleteEntities(LIVE_CHATS, ...liveChatUuids))
  }
)

export const bulkReadLiveChats = (liveChatUuids, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'chat/batch/read',
      data: { chatList: liveChatUuids },
      cancelToken
    })
    await dispatch(refetchLiveChats())
  }
)

export const bulkUnreadLiveChats = (liveChatUuids, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'chat/batch/unread',
      data: { chatList: liveChatUuids },
      cancelToken
    })
    await dispatch(refetchLiveChats())
  }
)

export const patchLiveChat = (chatUuid, data, cancelToken) => (
  async (dispatch, getState, api) => {
    const liveChat = await api({
      method: 'patch',
      apiPath: `chat/${chatUuid}`,
      data,
      cancelToken
    })
    // @todo
    dispatch(replaceEntities(LIVE_CHATS, { [chatUuid]: liveChat }))
  }
)
